import { render, staticRenderFns } from "./product_return_detail.vue?vue&type=template&id=344453ff&scoped=true"
import script from "./product_return_detail.vue?vue&type=script&lang=js"
export * from "./product_return_detail.vue?vue&type=script&lang=js"
import style0 from "./product_return_detail.vue?vue&type=style&index=0&id=344453ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344453ff",
  null
  
)

export default component.exports